import { useEffect, useState } from "react";
import { destructDuoDate } from "utils/helpers/duedateHelpers";
import { CustomComponentProps, PollObject } from "utils/types/generalTypes";

export type PollDueDateProps = CustomComponentProps & {
    poll: PollObject;
    updatePollDays: (d: number) => void;
    updatePollHours: (h: number) => void;
    updatePollMinutes: (mins: number) => void;
};

const PollDueDate = ({
    poll,
    updatePollDays,
    updatePollHours,
    updatePollMinutes
}: PollDueDateProps) => {
    const [minutes, setMinutes] = useState(5);
    const [hours, setHours] = useState(0);
    const [days, setDays] = useState(0);

    useEffect(() => {
        const date = destructDuoDate(poll.dueDate);
        setMinutes(date.minutes);
        setHours(date.hours);
        setDays(date.days);
    }, [poll.dueDate]);

    return (
        <div className="post-poll-section">
            <p className="momeento-p fw-500">Poll Length</p>
            <div className="d-flex flex-j-between flex-a-center gap-5">
                {/* poll days  */}
                <div className="poll-length-container d-flex flex-col flex-j-start flex-a-start">
                    <label
                        className="momeento-p fw-500"
                        // for="post-1-poll-days"
                    >
                        Days
                    </label>
                    <select
                        onChange={(e) => updatePollDays(Number(e.target.value))}
                        value={days}
                    >
                        <option value="0">0</option>
                        <option value="1">1</option>
                        <option value="2">2</option>
                        <option value="3">3</option>
                        <option value="4">4</option>
                        <option value="5">5</option>
                        <option value="6">6</option>
                        <option value="7">7</option>
                    </select>
                </div>
                {/* / poll days  */}

                {/* poll hours  */}
                <div className="poll-length-container">
                    <label className="momeento-p fw-500">Hours</label>
                    <select
                        onChange={(e) =>
                            updatePollHours(Number(e.target.value))
                        }
                        value={hours}
                    >
                        <option value="0">0</option>
                        <option value="1">1</option>
                        <option value="2">2</option>
                        <option value="3">3</option>
                        <option value="4">4</option>
                        <option value="5">5</option>
                        <option value="6">6</option>
                        <option value="7">7</option>
                        <option value="8">8</option>
                        <option value="9">9</option>
                        <option value="10">10</option>
                        <option value="11">11</option>
                        <option value="12">12</option>
                        <option value="13">13</option>
                        <option value="14">14</option>
                        <option value="15">15</option>
                        <option value="16">16</option>
                        <option value="17">17</option>
                        <option value="18">18</option>
                        <option value="19">19</option>
                        <option value="20">20</option>
                        <option value="21">21</option>
                        <option value="22">22</option>
                        <option value="23">23</option>
                    </select>
                </div>
                {/* / poll hours  */}

                {/* poll minutes  */}
                <div className="poll-length-container">
                    <label
                        className="momeento-p fw-500"
                        // for="post-1-poll-minutes"
                    >
                        Minutes
                    </label>
                    <select
                        onChange={(e) =>
                            updatePollMinutes(Number(e.target.value))
                        }
                        value={minutes}
                    >
                        {poll.dueDate > 59 ? (
                            <>
                                <option value="0">0</option>
                                <option value="1">1</option>
                                <option value="2">2</option>
                                <option value="3">3</option>
                                <option value="4">4</option>
                                <option value="5">5</option>
                            </>
                        ) : (
                            <option value="5">5</option>
                        )}
                        <option value="6">6</option>
                        <option value="7">7</option>
                        <option value="8">8</option>
                        <option value="9">9</option>
                        <option value="10">10</option>
                        <option value="11">11</option>
                        <option value="12">12</option>
                        <option value="13">13</option>
                        <option value="14">14</option>
                        <option value="15">15</option>
                        <option value="16">16</option>
                        <option value="17">17</option>
                        <option value="18">18</option>
                        <option value="19">19</option>
                        <option value="20">20</option>
                        <option value="21">21</option>
                        <option value="22">22</option>
                        <option value="23">23</option>
                        <option value="24">24</option>
                        <option value="25">25</option>
                        <option value="26">26</option>
                        <option value="27">27</option>
                        <option value="28">28</option>
                        <option value="29">29</option>
                        <option value="30">30</option>
                        <option value="31">31</option>
                        <option value="32">32</option>
                        <option value="33">33</option>
                        <option value="34">34</option>
                        <option value="35">35</option>
                        <option value="36">36</option>
                        <option value="37">37</option>
                        <option value="38">38</option>
                        <option value="39">39</option>
                        <option value="40">40</option>
                        <option value="41">41</option>
                        <option value="42">42</option>
                        <option value="43">43</option>
                        <option value="44">44</option>
                        <option value="45">45</option>
                        <option value="46">46</option>
                        <option value="47">47</option>
                        <option value="48">48</option>
                        <option value="49">49</option>
                        <option value="50">50</option>
                        <option value="51">51</option>
                        <option value="52">52</option>
                        <option value="53">53</option>
                        <option value="54">54</option>
                        <option value="55">55</option>
                        <option value="56">56</option>
                        <option value="57">57</option>
                        <option value="58">58</option>
                        <option value="59">59</option>
                    </select>
                </div>
                {/* / poll minutes  */}
            </div>
        </div>
    );
};

export default PollDueDate;
